var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overline",class:['group-by-parents-label', _vm.labelClass],style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.groupByParentsForDisplay))]),_c('div',{staticClass:"body-2",class:['group-by-label', _vm.labelClass],style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.groupByValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }